import { Theme } from '@mui/material/styles'

export interface StyleProps {
  hasError: boolean
  increaseEmphasis: boolean
  isChecked: boolean
  alignOnTop: boolean
}

const getColor = (
  theme: Theme,
  { hasError, isChecked }: Partial<StyleProps>
) => {
  if (isChecked) {
    return theme.palette.primary.main
  }

  if (hasError) {
    return theme.palette.error.main
  }

  return theme.palette.grey[700]
}

const styles = (
  theme: Theme,
  { hasError, increaseEmphasis, isChecked, alignOnTop }: StyleProps
) => ({
  checkbox: {
    '& svg': {
      color: getColor(theme, { hasError, isChecked })
    }
  },
  formLabel: {
    '& > span': {
      fontSize: increaseEmphasis
        ? theme.typography.body1.fontSize
        : '0.8125rem',
      paddingTop: alignOnTop ? 0 : 'inherit',
      alignSelf: alignOnTop ? 'flex-start' : 'unset'
    }
  }
})

export default styles
